__turbopack_context__.v({
  "action": "PhotoFrame-module__zhCKwq__action",
  "active": "PhotoFrame-module__zhCKwq__active",
  "android": "PhotoFrame-module__zhCKwq__android",
  "camera": "PhotoFrame-module__zhCKwq__camera",
  "canvas-container": "PhotoFrame-module__zhCKwq__canvas-container",
  "close_button": "PhotoFrame-module__zhCKwq__close_button",
  "controls": "PhotoFrame-module__zhCKwq__controls",
  "frame": "PhotoFrame-module__zhCKwq__frame",
  "frame-container": "PhotoFrame-module__zhCKwq__frame-container",
  "frame_ios": "PhotoFrame-module__zhCKwq__frame_ios",
  "image_canvas": "PhotoFrame-module__zhCKwq__image_canvas",
  "is-video": "PhotoFrame-module__zhCKwq__is-video",
  "main-container": "PhotoFrame-module__zhCKwq__main-container",
  "media": "PhotoFrame-module__zhCKwq__media",
  "media-type": "PhotoFrame-module__zhCKwq__media-type",
  "modal-body": "PhotoFrame-module__zhCKwq__modal-body",
  "movable": "PhotoFrame-module__zhCKwq__movable",
  "reset": "PhotoFrame-module__zhCKwq__reset",
  "shutter": "PhotoFrame-module__zhCKwq__shutter",
  "shutter-container": "PhotoFrame-module__zhCKwq__shutter-container",
  "swap-camera": "PhotoFrame-module__zhCKwq__swap-camera",
  "video": "PhotoFrame-module__zhCKwq__video",
  "video_canvas": "PhotoFrame-module__zhCKwq__video_canvas",
});
